export const chessFieldsNames = {
  address: 'address',
  numberOfEntrances: 'numberOfEntrances',
  numberOfFloors: 'numberOfFloors',
  numberOfFlats: 'numberOfFlats',
  isLoft: 'isLoft',
  isBasement: 'isBasement',
  isUndergroundParking: 'isUndergroundParking',
  isGroundFloor: 'isGroundFloor',
  isOfficeFloor: 'isOfficeFloor',
  isNumbering: 'isNumbering',
  fromFlatNumber: 'fromFlatNumber',
  differentFloorKeys: 'differentFloorKeys',
  differentFloorEntrance: 'differentFloorEntrance',
  differentFloorNumOf: 'differentFloorNumOf',
  differentFlatNumOf: 'differentFlatNumOf',
  differentNumberOfFlatsKeys: 'differentNumberOfFlatsKeys',
  differentNumberOfFlatsEntrance: 'differentNumberOfFlatsEntrance',
  differentNumberOfFlatsFloor: 'differentNumberOfFlatsFloor',
  differentNumberOfFlats: 'differentNumberOfFlats',
  officeKeys: 'officeFloorKeys',
  officeEntrance: 'officeEntrance',
  officeFloor: 'officeFloor',
  numberOfOffices: 'numberOfOffices',
  isOfficesInCommonNumbering: 'isOfficesInCommonNumbering',
};
